import { assertIsDefined } from '@sgme/fp';

export function getFileCompactSize(sizeInBytes: number): {
  size: number;
  unit: 'byte' | 'kilobyte' | 'megabyte' | 'gigabyte';
} {
  const lastUnit = UNIT_BY_SIZE[UNIT_BY_SIZE.length - 1];
  assertIsDefined(lastUnit, 'UNIT_BY_SIZE is a non-empty const array');

  const unitBySize = UNIT_BY_SIZE.find(({ maxSize }) => sizeInBytes < maxSize) ?? lastUnit;

  return {
    size: sizeInBytes / (unitBySize.maxSize / 1024),
    unit: unitBySize.unit,
  };
}

const UNIT_BY_SIZE = [
  { unit: 'byte', maxSize: 1024 },
  { unit: 'kilobyte', maxSize: 1024 ** 2 },
  { unit: 'megabyte', maxSize: 1024 ** 3 },
  { unit: 'gigabyte', maxSize: 1024 ** 4 },
] as const;
